import { render, staticRenderFns } from "./TopicChip.vue?vue&type=template&id=bad50534&scoped=true&"
import script from "./TopicChip.vue?vue&type=script&lang=js&"
export * from "./TopicChip.vue?vue&type=script&lang=js&"
import style0 from "./TopicChip.vue?vue&type=style&index=0&id=bad50534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad50534",
  null
  
)

export default component.exports